// app/javascript/controllers/carousel_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["track", "paginationText", "paginationList", "prevButton", "nextButton"]    
    static values = {
        perPage: { type: Number, default: 8 },
        currentPage: { type: Number, default: 1 },
        itemId: Number // <- 상위에서 넘긴 item.id
    }

  connect() {
    const isMobile = window.innerWidth < 768;
    this.perPageValue = isMobile ? 4 : this.perPageValue;
    this.totalItems = this.trackTarget.children.length
    this.totalPages = Math.ceil(this.totalItems / this.perPageValue)

    console.log(this);
    if (this.hasItemIdValue && this.itemIdValue != null) {
      const children = Array.from(this.trackTarget.children)
      const targetIndex = children.findIndex(
        el => parseInt(el.dataset.itemId) === this.itemIdValue
      )
      if (targetIndex !== -1) {
        this.currentPageValue = Math.floor(targetIndex / this.perPageValue) + 1
      }
      this.render()
    } else {
      // itemId가 없으면 전체를 보여주고, 컨트롤러 요소 숨김
      this.showAllItems()
      this.hideCarouselControls()
    }
  }

  showAllItems() {
    Array.from(this.trackTarget.children).forEach(el => {
      el.classList.remove("tw-hidden")
    })
  }

  hideCarouselControls() {
    if (this.hasPaginationTextTarget) {
      this.paginationTextTarget.classList.add("tw-hidden")
    }
    if (this.hasPaginationListTarget) {
      this.paginationListTarget.classList.add("tw-hidden")
    }
    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.classList.add("tw-hidden")
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.add("tw-hidden")
    }
  }

  render() {
  const start = (this.currentPageValue - 1) * this.perPageValue
  const end = start + this.perPageValue

  // 보여줄 item 조절
  Array.from(this.trackTarget.children).forEach((el, index) => {
    el.classList.toggle("tw-hidden", index < start || index >= end)
  })

  // 모바일용 페이지 텍스트
  if (this.hasPaginationTextTarget) {
    this.paginationTextTarget.textContent = `${this.currentPageValue} / ${this.totalPages}`
  }

  // PC용 페이지 리스트 렌더링
  if (this.hasPaginationListTarget) {
    this.paginationListTarget.innerHTML = ""

    for (let i = 1; i <= this.totalPages; i++) {
      const isCurrent = i === this.currentPageValue
      const wrapper = document.createElement("div")
      wrapper.setAttribute("data-속성-1", isCurrent ? "focus" : "default")
      wrapper.className = "tw-inline-flex tw-w-5 tw-flex-col tw-items-center tw-justify-center tw-gap-2" + (isCurrent ? " tw-border-b-2 tw-px-0.5" : "")

      const innerDiv = document.createElement("div")
      innerDiv.className =
        "tw-justify-center tw-self-stretch tw-text-center tw-text-xs" +
        (isCurrent ? "tw-font-bold tw-text-gray-800" : "tw-font-medium tw-text-gray-600")

      innerDiv.textContent = i
      innerDiv.style.cursor = "pointer"

      innerDiv.addEventListener("click", () => {
        this.currentPageValue = i
        this.render()
      })

      // 왼쪽 버튼 비활성 처리
        if (this.hasPrevButtonTarget) {
            const isDisabled = this.currentPageValue === 1;
            this.prevButtonTarget.classList.remove("tw-text-black", "tw-text-gray-100", "tw-pointer-events-none");
            this.prevButtonTarget.classList.add(
                isDisabled ? "tw-text-gray-100" : "tw-text-black"
            );
            if (isDisabled) {
                this.prevButtonTarget.classList.add("tw-pointer-events-none");
            }
        }

        if (this.hasNextButtonTarget) {
            const isDisabled = this.currentPageValue === this.totalPages;
            this.nextButtonTarget.classList.remove("tw-text-black", "tw-text-gray-100", "tw-pointer-events-none");
            this.nextButtonTarget.classList.add(
                isDisabled ? "tw-text-gray-100" : "tw-text-black"
            );
            if (isDisabled) {
                this.nextButtonTarget.classList.add("tw-pointer-events-none");
            }
        }

      if (isCurrent) {
        const innerWrapper = document.createElement("div")
        innerWrapper.className =
          "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-self-stretch tw-border-b-2 tw-border-mainOrange-light tw-px-0.5"
        innerWrapper.appendChild(innerDiv)
        wrapper.appendChild(innerWrapper)
      } else {
        wrapper.appendChild(innerDiv)
      }

      this.paginationListTarget.appendChild(wrapper)
    }
  }
}
  previous() {
    if (this.currentPageValue > 1) {
      this.currentPageValue--
      this.render()
    }
  }

  next() {
    if (this.currentPageValue < this.totalPages) {
      this.currentPageValue++
      this.render()
    }
  }
}